export default __webpack_public_path__ + "static/media/hero-image1.5a7fcb0e.jpg";